export function SkillPreview({ content, name }) {
  // Simple markdown-to-HTML renderer (handles headers, lists, code blocks, bold, tables)
  const renderMarkdown = (md) => {
    if (!md) return '';
    let html = md
      // Code blocks
      .replace(/```(\w*)\n([\s\S]*?)```/g, '<pre class="bg-gray-800 rounded-lg p-3 text-xs overflow-x-auto my-2"><code class="text-emerald-300">$2</code></pre>')
      // Headers
      .replace(/^### (.+)$/gm, '<h3 class="text-sm font-semibold text-gray-200 mt-4 mb-1">$1</h3>')
      .replace(/^## (.+)$/gm, '<h2 class="text-sm font-bold text-violet-300 mt-5 mb-2 border-b border-gray-800 pb-1">$1</h2>')
      .replace(/^# (.+)$/gm, '<h1 class="text-base font-bold text-gray-100 mb-3">$1</h1>')
      // Bold
      .replace(/\*\*(.+?)\*\*/g, '<strong class="text-gray-200">$1</strong>')
      // Inline code
      .replace(/`([^`]+)`/g, '<code class="bg-gray-800 text-violet-300 px-1 py-0.5 rounded text-xs">$1</code>')
      // List items
      .replace(/^- (.+)$/gm, '<li class="text-gray-400 text-xs ml-4 list-disc">$1</li>')
      // Table rows
      .replace(/^\|(.+)\|$/gm, (match, content) => {
        const cells = content.split('|').map(c => c.trim());
        const isHeader = cells.every(c => /^-+$/.test(c));
        if (isHeader) return '';
        const tag = 'td';
        return `<tr>${cells.map(c => `<${tag} class="border border-gray-700 px-2 py-1 text-xs text-gray-300">${c}</${tag}>`).join('')}</tr>`;
      })
      // Paragraphs (lines that aren't already HTML)
      .replace(/^(?!<)((?!^\s*$).+)$/gm, (match) => {
        if (match.startsWith('<')) return match;
        return `<p class="text-xs text-gray-400 my-1">${match}</p>`;
      });

    // Wrap table rows
    html = html.replace(/(<tr>[\s\S]*?<\/tr>)+/g, '<table class="border-collapse border border-gray-700 my-2 w-full">$&</table>');

    return html;
  };

  return (
    <div className="w-96 bg-gray-900/50 border-l border-gray-800 overflow-y-auto">
      <div className="px-5 py-3 border-b border-gray-800">
        <h3 className="text-xs font-semibold text-gray-500 uppercase tracking-wider">Preview</h3>
        <p className="text-[11px] text-gray-600 mt-0.5">What the agent sees when load_skill("{name}") is called</p>
      </div>
      <div className="px-5 py-4">
        {content ? (
          <div
            className="prose prose-invert prose-xs max-w-none"
            dangerouslySetInnerHTML={{ __html: renderMarkdown(content) }}
          />
        ) : (
          <p className="text-xs text-gray-600 italic">Start typing in the editor to see preview</p>
        )}
      </div>
    </div>
  );
}
